import {Component, Inject} from "@angular/core";
import {AgentLeadType, FelloVisitorVariables, SaleTimeline, SaleTimelineLabel} from "fello-model";
import {QuestionCardDirective} from "../../../directives/question-card/question-card.directive";
import {FELLO_JOURNEY_TASK_ID} from "../../../injection-token";
import {OfferJourneyService} from "../../../services/offer-journey/offer-journey.service";

@Component({
  selector: "app-que-timeline",
  templateUrl: "./que-timeline.component.html",
  styleUrls: ["./que-timeline.component.scss"]
})
export class QueTimelineComponent extends QuestionCardDirective {
  saleTimeline: SaleTimeline | null;
  SaleTimeline = SaleTimeline;
  SaleTimelineLabel = SaleTimelineLabel;

  constructor(public offerJourneyService: OfferJourneyService, @Inject(FELLO_JOURNEY_TASK_ID) public taskId: string) {
    super(offerJourneyService, taskId);
    this.saleTimeline = this.offerJourney.vars.saleTimeline ? (this.offerJourney.vars.saleTimeline as SaleTimeline) : null;
  }
  get leadType(): AgentLeadType {
    return this.offerJourney.leadType!;
  }

  submit(saleTimeline: SaleTimeline): void {
    const vars: FelloVisitorVariables = {
      saleTimeline: saleTimeline
    };
    this.offerJourneyService.pushOfferJourneyTask(this.taskId, vars).subscribe();
  }
}
